var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile is-child box",on:{"click":function($event){return _vm.onVideoSelect(_vm.video)}}},[_c('img',{staticStyle:{"width":"220px","padding":"10px"},attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }